import Infographics from './Infographics'

export default Infographics
